import { useEffect, useState } from "react";
import { StandardGridToolbar } from "../../../../../components/ToolbarKit";
import API from "../../../../../api";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  renderTypeCell,
  TOEstablishTheColorOfLog,
} from "../../../../../components/ImportantFunctions";
import CircularIndeterminate from "../../../../../components/circularProgress";
import { Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TriangleChartTooltip from "./TriangleStat";
import { dataGridStyle } from "../../../../../theme";

const DetailTable = ({ detailMap }) => {
  const [anomaliesLog, setAnomaliesLog] = useState([]);
  const [charged, setCharged] = useState(false);
  const timeZone = window.sessionStorage.getItem("timezone");
  const navigate = useNavigate();

  const handleLinkClick = (highlightDettaglio, tipo, timeStamp) => {
    const infoPages = {
      1: {url: "critical", tab: "Critical"},
      0: {url: "high", tab: "High"},
      2: {url: "alert", tab: "Alert"},
      3: {url: "movements", tab: "Movements"},
      4: {url: "threat-intelligence", tab: "Threat Intelligence"},
    }

    sessionStorage.setItem("selectedTab", infoPages[tipo].tab);
    if (sessionStorage.getItem("type") === "reseller")
      navigate(`/reseller/myC/${infoPages[tipo].url}?exact_details=${highlightDettaglio}&dateFrom=${timeStamp}&dateTo=${timeStamp}`);
    else
      navigate(`/user/security/${infoPages[tipo].url}?exact_details=${highlightDettaglio}&dateFrom=${timeStamp}&dateTo=${timeStamp}`);
  };

  useEffect(() => {
    setAnomaliesLog([]);
    setCharged(false);
    API.getTiresia({ groupedQuery: true, dettaglio: detailMap })
      .then((res) => {
        const transformData = res.data.map((item, index) => ({
          id: index,
          ...item,
        }));
        setAnomaliesLog(transformData);
        setCharged(true);
      })
      .catch((err) => {
        console.error(err);
        setCharged(true);
      });
  }, [detailMap]);

  const columns = [
    {
      field: "timeStamp",
      headerName: `TIMESTAMP (${timeZone ? timeZone : "GMT"})`,
      minWidth: 180,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "dettaglio",
      headerName: "Detail",
      headerAlign: "center",
      flex: 1,
      minWidth: 200,
      align: "left",
      renderCell: (params) => {
        const detail = params.value;
        return (
          <div
            className="detail-clickable-cell"
            style={{
              width: "auto",
              color: TOEstablishTheColorOfLog(detail),
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
              gap: 20,
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "logStat",
      headerName: "LOG STAT",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      align: "center",
      renderCell: (params) => {
        const detail = params.row.dettaglio;
        const ipSorgente = params.row.ipSorgente;
        const ipDestinatario = params.row.ipDestinatario;
        const timeStamp = params.row.timeStamp;
        return (
                <TriangleChartTooltip
                  detail={detail}
                  ipSorgente={ipSorgente}
                  ipDestinatario={ipDestinatario}
                  timeStamp={timeStamp}
                />
        );
      },
    },
    {
      field: "tipo",
      headerName: "Type",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      align: "center",
      renderCell: renderTypeCell,
    },
    {
      field: "ipSorgente",
      headerName: "Source IP",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      align: "center",
    },
    {
      field: "ipDestinatario",
      headerName: "Dest IP",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      align: "center",
    },
    {
      field: "score",
      headerName: "Score",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      align: "center",
      renderCell: (params) => {
        return (
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 900,
              color:
                params.value <= 0.89
                  ? "#8963b2"
                  : params.value <= 0.98
                  ? "orange"
                  : "red",
            }}
          >
            {(params.value * 100).toFixed(2)} %
          </Typography>
        );
      },
    },
    {
      field: "main-table",
      headerName: "MAIN TABLE",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      align: "center",
      renderCell: (params) => (
        <Button
          sx={{
            backgroundColor: "#2d2d2d !important",
            color: "#eaeaea !important",
            fontWeight: 900,
            "&:hover": {
              backgroundColor: "#eaeaea !important",
              color: "#131C2D !important",
            },
          }}
          onClick={() => {
            handleLinkClick(params.row.dettaglio, params.row.tipo, params.row.timeStamp);
          }}
        >
          Main Table
        </Button>
      ),
    },
  ];
  return (
    <>
      {anomaliesLog.length > 0 ? (
        <DataGridPro
          showToolbar
          slots={{ toolbar: StandardGridToolbar }}
          sx={{ ...dataGridStyle, height: "30vh"}}
          rows={anomaliesLog}
          columns={columns}
          pagination
        />
      ) : (
        <CircularIndeterminate charged={charged} title="No Data" />
      )}
    </>
  );
};

export default DetailTable;
